var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 84,
    viewBox: "0 0 269 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.077 10.9737C247.077 17.0381 251.981 21.9473 258.039 21.9473C264.096 21.9473 269 17.0381 269 10.9737C269 4.90929 264.096 0 258.039 0C251.981 0 247.077 4.90929 247.077 10.9737Z",
    fill: "#A1CC3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.555 10.9737C123.555 17.0381 128.458 21.9473 134.516 21.9473C140.574 21.9473 145.477 17.0381 145.477 10.9737C145.477 4.90929 140.574 0 134.516 0C128.458 0 123.555 4.90929 123.555 10.9737Z",
    fill: "#A1CC3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.9737C0 17.0381 4.90373 21.9473 10.9613 21.9473C17.0188 21.9473 21.9226 17.0381 21.9226 10.9737C21.9226 4.90929 17.0188 0 10.9613 0C4.90373 0 0 4.90929 0 10.9737Z",
    fill: "#A1CC3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M247.077 72.921C247.077 78.9854 251.981 83.8948 258.039 83.8948C264.096 83.8948 269 78.9854 269 72.921C269 66.8567 264.096 61.9474 258.039 61.9474C251.981 61.9474 247.077 66.8567 247.077 72.921Z",
    fill: "#A1CC3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.555 72.921C123.555 78.9854 128.458 83.8948 134.516 83.8948C140.574 83.8948 145.477 78.9854 145.477 72.921C145.477 66.8567 140.574 61.9474 134.516 61.9474C128.458 61.9474 123.555 66.8567 123.555 72.921Z",
    fill: "#A1CC3A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 72.921C0 78.9854 4.90373 83.8948 10.9613 83.8948C17.0188 83.8948 21.9226 78.9854 21.9226 72.921C21.9226 66.8567 17.0188 61.9474 10.9613 61.9474C4.90373 61.9474 0 66.8567 0 72.921Z",
    fill: "#A1CC3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/DOTS.45ae639cbaeca970fd8af97afa50535c.svg";
export { ForwardRef as ReactComponent };